/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.Choudhary@mroads.com>, February 2021
 * @format
 * @flow
 */

import { all, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../../requests';
import { callAPI } from './callAPI';
import { callAPILogin } from './callAPILogin';

export function* initializeCashPayment({ payload }): any {
  yield callAPI(payload, ActionTypes.CASH_PAYMENT, API.initializeCashPayment, true);
}

export function* initializePayment({ payload }): any {
  yield callAPI(payload, ActionTypes.CARD_PAYMENT, API.initializePayment, true);
}

export function* paymentIngenicoComplete({ payload }): any {
  yield callAPI(payload, ActionTypes.PAYMENT_INGENICO_COMPLETE, API.paymentIngenicoComplete);
}

export function* validateGiftCard({ payload }): any {
  yield callAPILogin(payload, ActionTypes.VALIDATE_GIFTCARD, API.validateGiftCard);
}

export function* paymentGiftCardInit({ payload }): any {
  yield callAPI(payload, ActionTypes.PAYMENT_GIFT_CARD_INIT, API.paymentGiftCardInit);
}

export function* paymentGiftCardComplete({ payload }): any {
  yield callAPI(payload, ActionTypes.PAYMENT_GIFT_CARD_COMPLETE, API.paymentGiftCardComplete);
}

export function* retryPOSPayment({ payload }): any {
  yield callAPI(payload, ActionTypes.RETRY_POS_PAYMENT, API.retryPOSPayment);
}

export default function* root(): any {
  yield all([takeLatest(ActionTypes.CASH_PAYMENT_REQUEST, initializeCashPayment)]);
  yield all([takeLatest(ActionTypes.CARD_PAYMENT_REQUEST, initializePayment)]);
  yield all([takeLatest(ActionTypes.PAYMENT_INGENICO_COMPLETE_REQUEST, paymentIngenicoComplete)]);
  yield all([takeLatest(ActionTypes.VALIDATE_GIFTCARD_REQUEST, validateGiftCard)]);
  yield all([takeLatest(ActionTypes.PAYMENT_GIFT_CARD_INIT_REQUEST, paymentGiftCardInit)]);
  yield all([takeLatest(ActionTypes.PAYMENT_GIFT_CARD_COMPLETE_REQUEST, paymentGiftCardComplete)]);
  yield all([takeLatest(ActionTypes.RETRY_POS_PAYMENT_REQUEST, retryPOSPayment)]);
}
